import { managerV2BaseUrl } from '@/utils';
import { useTranslation } from 'react-i18next';
import { CSSProperties } from 'react';
import { mapMarkierung } from '@/domain/navigation/benachrichtigungen/utils/mapMarkierung';
import { Link } from 'react-router-dom';
import { FehlendeArbeitszeiten } from '@/domain/navigation/benachrichtigungen/types/FehlendeArbeitszeiten';
import { DetailWrapper } from '@/domain/navigation/benachrichtigungen/components/details/shared/DetailWrapper';
import { getTranslationKeyForDay } from '@/domain/navigation/benachrichtigungen/components/details/shared/getTranslationKeyForDay';

type StyleProps = CSSProperties & {
  '--dot-color': CSSProperties['color'];
};

export default function FehlendeArbeitszeitDetail({
  benachrichtigung,
}: {
  benachrichtigung: FehlendeArbeitszeiten;
}) {
  const { t } = useTranslation();

  const linkTo = `${managerV2BaseUrl}/arbeitszeiten/uebersicht/${benachrichtigung.datum.format(
    'YYYY',
  )}/${benachrichtigung.datum.format('MM')}/${benachrichtigung.datum.format(
    'DD',
  )}/sheet/antrag/${benachrichtigung.id}`;

  return (
    <Link to={linkTo}>
      <DetailWrapper
        mitarbeiter={benachrichtigung.mitarbeiter}
        content={
          <div className="w-fit h-5 px-2 py-1 bg-neutrals-N300 rounded-full inline-flex justify-center items-center gap-1">
            <div
              className="w-2 h-2 bg-[var(--dot-color)] rounded-full"
              style={
                {
                  '--dot-color':
                    mapMarkierung[benachrichtigung.arbeitsbereich.markierung]
                      .base,
                } as StyleProps
              }
            />
            <div className="text-center justify-start text-neutrals-N900 text-xs font-semibold  leading-none">
              {benachrichtigung.arbeitsbereich.name}
            </div>
          </div>
        }
        footer={
          <>
            {t(getTranslationKeyForDay(benachrichtigung.datum.day()))}.,{' '}
            {benachrichtigung.datum.format('DD.MM.YYYY')}
          </>
        }></DetailWrapper>
    </Link>
  );
}
